<template>
    <div class="header">
        <div class="vcore_container">
            <span class="header-text"
                  @click="returnHome">
                Prototype Manager
            </span>
            <button
                    class="vcore_btn add-project-button blue-button"
                    type="button"
                    @click="newProject"
                    v-if="access === 'admin'"
            >
                <i class="vcore_icon icon-document"></i>
                New Project
            </button>
            <button
                    class="vcore_btn logout-button"
                    type="button"
                    v-if="access === 'admin' || access === 'user'"
                    @click="logout"
            >
                Log Out
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Header",
        methods: {
            returnHome(){
                this.$router.push("/");
            },
            newProject(){
                this.$router.push("/new");
            },
            logout(){
                this.$store.commit("authTokenUpdate", "");
                this.$store.commit("usernameUpdate", "");
                this.$store.commit("adminUpdate", "");
            }
        },
        props: {
            access: {
                type: String
            }
        }
    }
</script>

<style scoped lang="scss">
    .vcore_row {
        margin: 0;
    }

    .header {
        background-color: white;
        border-bottom: 1px solid #DDDDDD;
        width: 100%;
        height: 72px;
    }

    .header-text {
        font-family: "Open Sans", sans-serif;
        font-style: normal;
        font-weight: 600;
        font-size: 32px;
        line-height: 72px;
        float: left;
        color: #2b78e4;
        cursor: pointer;
    }

    .logout-button{
        float: right;
        background-color: transparent;
        font-size: 18px;
        font-weight: 600;
        margin: 0 35px;
        color: #2b78e4;
        line-height: 72px;
    }

    .add-project-button {
        float: right;
        font-size: 18px;
        font-weight: 600;
        padding: 10px 30px;
        min-width: 150px;
        position: relative;
        top:14px;
    }


</style>